import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("documind_token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => setUser(r.data))
      .catch(() => localStorage.removeItem("documind_token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    localStorage.setItem("documind_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const signup = async (email, password, name) => {
    const { data } = await api.post("/auth/signup", { email, password, name });
    localStorage.setItem("documind_token", data.token);
    setUser(data.user);
    return data.user;
  };
  const logout = () => {
    localStorage.removeItem("documind_token");
    setUser(null);
  };
  const refresh = useCallback(() => api.get("/auth/me").then((r) => setUser(r.data)).catch((e) => console.warn("Session refresh failed", e)), []);
  const acceptSession = useCallback((data) => {
    localStorage.setItem("documind_token", data.token);
    setUser(data.user);
  }, []);

  return <AuthCtx.Provider value={{ user, loading, login, signup, logout, refresh, acceptSession }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
export const getToken = () => localStorage.getItem("documind_token");
export const rememberNext = (path) => { if (path && path.startsWith("/") && path !== "/app") sessionStorage.setItem("documind_next", path); };
export const takeNext = () => {
  const n = sessionStorage.getItem("documind_next");
  sessionStorage.removeItem("documind_next");
  return n && n.startsWith("/") ? n : "/app";
};
